import type { ActionFlowNode, FlowNodeResultADT, SendMsgDingTalkRobotActionConfigure, SendMsgDingTalkRobotConfig } from '@lighthouse/shared'
import { getDingTalkRobotVariableValue } from '@lighthouse/shared'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleDingTalkRobot = async (
    node: ActionFlowNode<SendMsgDingTalkRobotActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const dingTalkRobotPayload = getDingTalkRobotVariableValue(config, params)

    await srv.activeDingTalkRobotAction({
        config: dingTalkRobotPayload
    })

    return { type: 'record', success: true }
}
